import { useStorageKey } from "#src/hooks/useStorageKey";
import React from "react";
import { ConfigurationTemplateRunsFilterPanel } from "./ConfigurationTemplateRunsFilterPanel";
import { ConfigurationTemplateRunsTablePanel } from "./ConfigurationTemplateRunsTablePanel";

export const ConfigurationTemplateRunsListTab = () => {
  const [tableConfigStorageKey, viewConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["table-configuration", "view-configuration", "table-state"],
      "configuration-template-submissions"
    );

  return (
    <>
      <ConfigurationTemplateRunsFilterPanel
        viewConfigStorageKey={viewConfigStorageKey}
      />
      <ConfigurationTemplateRunsTablePanel
        viewConfigStorageKey={viewConfigStorageKey}
        tableConfigStorageKey={tableConfigStorageKey}
        tableStateStorageKey={tableStateStorageKey}
      />
    </>
  );
};
